/* global angular, jQuery, mintel_tracking */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('labelBlock', ['Api',
    function (Api) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var item_id = attrs.labelBlock;
                Api.labels.label.getList({
                    'trend': item_id
                }).then(function(results) {
                    scope.labels = results;
                });
            }
        };
    }
]);

ngModule.directive('infoBarDropdown', ['$dropdown', '$timeout', 'PptService',
    function ($dropdown, $timeout, PptService) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var trigger = attrs.trigger || 'click';
                var item_id = attrs.itemId;
                var template_name = '/trends/partials/dropdowns/' + attrs.infoBarDropdown + '_dropdown/';
                if (item_id !== undefined) {
                    template_name += item_id + '/';
                }
                var placement = 'bottom-left';
                if (attrs.infoBarDropdown === 'pptbuilder') {
                    PptService.pageTitle = attrs.itemTitle;
                    PptService.pageContentType = attrs.contentType;
                    PptService.pageDisplaydate = attrs.itemDisplaydate;
                    placement = 'left';
                }
                scope.dropdown = $dropdown(element, {
                    scope: scope,
                    show: false,
                    trigger: trigger,
                    template: template_name,
                    placement: placement,
                    html: true
                });
                scope.toggleDropdown = function() {
                    if(!scope.dropdown.$isShown) {
                        scope.dropdown.show();
                        mintel_tracking.view('Sidebar', {
                            'Panel': 'My Presentations'
                        });
                        $timeout(function() {
                            $(attrs.focus).focus();
                        });
                    }
                    else {
                        scope.dropdown.hide();
                    }
                };
            }
        };
    }
]);

ngModule.directive('infoBarApiDropdown', ['Api', '$dropdown',
    function (Api, $dropdown) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var item_id = attrs.infoBarApiDropdown;
                Api.labels.label.getList({
                    'trend': item_id
                }).then(function(results) {
                    var dropdown = $dropdown(element, {
                        scope: scope,
                        show: false,
                        template:'/trends/partials/dropdowns/label_dropdown/',
                        html: true
                    });

                    var final_results = [];
                    for (var n=0 ; n < results.meta.total_count ; n++) {
                        final_results.push({
                            'text': results[n].description,
                            'id': results[n].pk
                        });
                    }
                    dropdown.$scope.content = final_results;
                });
            }
        };
    }
]);

